export default "__VITE_ASSET__a3X4poEI__"